import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { SearchFilteredRecipesInterface } from "../app/search/search.types";
import { useAppSelector } from "../app/store/hooks";
import { UrlFilters } from "../hooks/useFilterRecipe.types";
import styles from "../pages/specificCategoryPage.module.css";
import ListView from './listViewPage/ListView';

interface ListViewRecipesProps {
  loading: boolean;
  recipes: SearchFilteredRecipesInterface[];
  filters: UrlFilters; 
}

const ListViewRecipes = ({ loading, recipes, filters }: ListViewRecipesProps) => {
  const user = useAppSelector((state) => state.main.user);

  if (loading) return <ListView loading={loading} recipes={recipes} />;

  if (Array.isArray(recipes) && recipes && recipes.length > 0) return <ListView loading={loading} recipes={recipes} />;

  if (filters.created_by && filters.created_by[0] === user?.id) {
    return (
      <Grid className={styles.not_found_text_creations}>
        <Typography variant='swipe'>Nothing here yet...</Typography>
        <Typography variant='card'>
          Click on the Create button on homepage to create delicious recipes.
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid className={styles.not_found_text_category}>
      <Typography variant='swipe'>Nothing here yet...</Typography>
      <Typography variant='card'>
        Please click on the Back button to browse other recipes.
      </Typography>
    </Grid>
  );
};

export default ListViewRecipes;
